export const searchEndpoints = {
  searchByRoleTypeByName: (roleType: string, name: string) =>
    `/api/search/users/role/${roleType}?name=${encodeURIComponent(name)}`,
};
